var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{staticStyle:{"overflow":"hidden"}},[(_vm.asset && _vm.latestVersion)?_c('PreviewAssetData',{attrs:{"data":_vm.latestVersion.data,"type":_vm.asset.type,"version":_vm.latestVersion._id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }